import { createContext } from 'react'

type CreationToolsWelcomeContextProps = {
    isDraggingFile: boolean
    setIsDraggingFile: (isDragging: boolean) => void
    onFileAdded?: (files: FileList) => void
}

export const CreationToolsWelcomeContext = createContext({} as CreationToolsWelcomeContextProps)
